import { ActivatedRouteSnapshot } from '@angular/router';

export const getRouteTemplate = (root: ActivatedRouteSnapshot): string => {
  const segments: string[] = [];

  for (let route: ActivatedRouteSnapshot | null = root; route; route = route.firstChild) {
    const path = route.routeConfig?.path;
    if (path) segments.push(path);
  }

  return `/${segments.join('/')}`;
};
